import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { localImages } from './constants/app-config';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: [
    './dashboard.component.css',
    'styles/styles.css'
  ]
})
export class DashboardComponent implements OnInit {
  @ViewChild('drawer') drawer!: ElementRef;
  localImages = localImages;
  queryParams: any;
  hidden = false;
  isMiniMode = false;

  constructor(private route: ActivatedRoute) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      this.queryParams = params;
      this.hidden = params.navbar_hidden == "true";
    });
  }

  onToggleMiniMode(isMini: boolean) {
    this.isMiniMode = isMini;
    // Force a reflow to ensure smooth transition
    if (this.drawer) {
      this.drawer.nativeElement.offsetHeight;
    }
  }
}
